import md5 from 'md5';

const getGravatar = (email: string) => {
    const emailMd5 = md5(email.toLowerCase());

    return 'https://gravatar.com/avatar/' + emailMd5 + '?d=identicon';
};

export { getGravatar };
